import { memo, useEffect, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import MenuList from '../MenuList';
import MiniDrawerStyled from './MiniDrawerStyled';

import LAYOUT_CONST from 'constant';
import useConfig from 'hooks/useConfig';
import { drawerWidth } from 'store/constant';

import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';
import useAuth from 'hooks/useAuth';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = () => {
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);
    const { navType } = useConfig();
    const { drawerType } = useConfig();
    const { kycLoaded } = useAuth();
    const drawer = (
        <PerfectScrollbar
            component="div"
            style={{
                height: 'auto',
                backgroundColor: matchUpMd ? (navType === 'dark' ? '#252525' : '#fff') : 'transparent',
                borderRadius: matchUpMd ? '16px' : '0'
            }}
        >
            {kycLoaded && <MenuList />}
        </PerfectScrollbar>
    );

    return (
        <Box
            component="nav"
            sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto', display: { md: 'flex', xs: 'none' } }}
            aria-label="mailbox folders"
        >
            {matchDownMd || (drawerType === LAYOUT_CONST.MINI_DRAWER && drawerOpen) ? (
                <Drawer
                    variant={matchUpMd ? 'persistent' : 'temporary'}
                    anchor="left"
                    open={drawerOpen}
                    onClose={() => dispatch(openDrawer(!drawerOpen))}
                    sx={{
                        '& .MuiDrawer-paper': {
                            mt: matchDownMd ? 0 : 11,
                            zIndex: 1099,
                            width: drawerWidth,
                            background: theme.palette.background.default,
                            color: theme.palette.text.primary,
                            borderRight: 'none'
                        }
                    }}
                    ModalProps={{ keepMounted: true }}
                    color="inherit"
                >
                    {matchDownMd}
                    {drawer}
                </Drawer>
            ) : (
                <MiniDrawerStyled
                    variant="permanent"
                    open={drawerOpen}
                    sx={{
                        '& .MuiDrawer-paper': {
                            position: 'relative !important'
                        }
                    }}
                >
                    {drawer}
                </MiniDrawerStyled>
            )}
        </Box>
    );
};

export default memo(Sidebar);
